import { get } from "lodash";

export default class User {
  id: string;
  name: string;
  familyName: string;
  displayName?: string;
  email: string;
  cognito_id: string;
  role: Array<string>;
  lang: string;
  token: string;
  token_exp: number;

  constructor(params?: User) {
    this.id = get(params, "id", "");
    this.name = get(params, "name", "");
    this.familyName = get(params, "familyName", "");
    this.email = get(params, "email", "");
    this.cognito_id = get(params, "cognito_id", "");
    this.role = get(params, "role", []);
    this.lang = get(params, "lang", "es");
    this.token = get(params, "token", "");
    this.token_exp = get(params, "token_exp", 0);
  }
}
